import request from '@/router/axios'
// 登录
export function Login(query) {
   return request({
      url: '/api/services/app/CommonApi/Login',
      method: 'post',
      data: query,
   })
}

//微信登录
export function WxLogin(query){
    return request(
        {
            url:"/api/services/app/CommonApi/WeChatLogin",
            method:"post",
            data:query
        }
    )
}


export function GetUrlParam(paraName) {
    var url = document.location.toString();
    var arrObj = url.split("?");

    if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;

        for (var i = 0; i < arrPara.length; i++) {
            arr = arrPara[i].split("=");

            if (arr != null && arr[0] == paraName) {
                return arr[1];
            }
        }
        return "";
    }
    else {
        return "";
    }
}

// 注册
export function Register(query) {
   return request({
      url: '/api/services/app/CommonApi/Register',
      method: 'post',
      data: query
   })
}

// 修改密码
export function ModifyPassword(query) {
   return request({
      url: '/api/services/app/CommonApi/ModifyPassword',
      method: 'post',
      data: query
   })
}


// 获取个人信息
export function GetPersonalInfo(query) {
   return request({
      url: '/api/services/app/CommonApi/GetPersonalInfo',
      method: 'post',
      data: query
   })
}

// 修改运动员个人信息
export function UpdateorInsertAthleteInfo(query) {
   return request({
      url: '/api/services/app/CommonApi/UpdateorInsertAthleteInfo',
      method: 'post',
      data: query,
   })
}

// 修改考评员员个人信息
export function UpdateorInsertCoachInfo(query) {
   return request({
      url: '/api/services/app/CommonApi/UpdateorInsertCoachInfo',
      method: 'post',
      data: query,
   })
}

// 修改测试机构信息
export function UpdateTestMechanism(query) {
   return request({
      url: '/api/services/app/TestOrg/UpdateTestMechanism',
      method: 'post',
      data: query,
   })
}

// 获取测试机构信息
export function GetUserTestMechanism(query) {
   return request({
      url: '/api/services/app/TestOrg/GetUserTestMechanism',
      method: 'post',
      data: query,
   })
}

// 简称查重
export function UpdateNickName(query) {
   return request({
      url: '/api/services/app/TestOrg/UpdateNickName',
      method: 'post',
      data: query
   })
}

// 获取验证码
export function GetMessageCode(query) {
   return request({
      url: '/api/services/app/CommonApi/GetMessageCode',
      method: 'post',
      data: query
   })
}

// 验证验证码
export function CheckPhoneNumber(query) {
   return request({
      url: '/api/services/app/CommonApi/CheckPhoneNumber',
      method: 'post',
      data: query
   })
}
// 找回密码
export function ForgetPassword(query) {
   return request({
      url: '/api/services/app/CommonApi/ForgetPassword',
      method: 'post',
      data: query
   })
}

// 批量运动员的手机号验证接口
export function MobileVerify(query) {
   return request({
      url: '/api/services/app/CommonApi/MobileVerify',
      method: 'post',
      data: query
   })
}


// 报名接口检测
export function CheckApply(query) {
	var tempPar = request({
       url: '/api/services/app/TestApplication/CheckApply',
       method: 'post',
       data: query
   });
   return tempPar;
}